import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.scss';
import './i18n';
import { useTranslation } from 'react-i18next';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import News from './pages/News';
import Careers from './pages/Careers';
import ContactUs from './pages/ContactUs';
import Charity from './pages/news/Charity';
import MeetingWithOfficer from './pages/news/MeetingWithOfficer';
import ReceivingCertificateFromCLA from './pages/news/ReceivingCertificateFromCLA';
import StrategyMeeting from './pages/news/StrategyMeeting';
import AnnualParty from './pages/news/AnnualParty';

const App: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className={`app lang-${i18n.language}`}>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/charity" element={<Charity />} />
            <Route path="/news/meeting-with-officer" element={<MeetingWithOfficer />} />
            <Route path="/news/receiving-certificate-from-cla" element={<ReceivingCertificateFromCLA />} />
            <Route path="/news/strategy-meeting" element={<StrategyMeeting />} />
            <Route path="/news/annual-party" element={<AnnualParty />} />
            <Route path="/career" element={<Careers />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
